/** Gold star row — `rating` filled, rest light gray. */
export function Stars({ rating, size = 11 }: { rating: number; size?: number }) {
  return (
    <span className="inline-flex" style={{ gap: 1 }}>
      {Array.from({ length: 5 }).map((_, k) => (
        <svg
          key={k}
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill={k < rating ? '#FFB400' : '#e0e0e0'}
          stroke="none"
        >
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ))}
    </span>
  );
}
